import { UsersImporterSlice } from '@hefe/store';
import { Button, Checkbox, Col, Row, Space } from 'antd';
import { t } from '@hefe/i18n';
import React, { useState } from 'react';
import { useAppDispatch } from '../../../../../store/store';

export default function UsersImportSettingsComponent() {
  const dispatch = useAppDispatch();

  const [sendMail, setSendMail] = useState(false);

  const onNext = () => {
    dispatch(
      UsersImporterSlice.usersImporterActions.setSettings({
        sendMail: sendMail,
      })
    );
    dispatch(UsersImporterSlice.usersImporterActions.incrementStep(4));
  };

  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      <Row>
        <Col xs={24}>
          <Checkbox
            checked={sendMail}
            onChange={(e) => setSendMail(e.target.checked)}
          >
            {t('users_importer.auto_activate')}
          </Checkbox>
        </Col>
      </Row>
      <Row justify="end">
        <Space>
          <Button
            onClick={() =>
              dispatch(UsersImporterSlice.usersImporterActions.decrementStep())
            }
          >
            {t('prev')}
          </Button>
          <Button onClick={() => onNext()}>{t('next')}</Button>
        </Space>
      </Row>
    </Space>
  );
}
